<template>
  <div class="header">
    <div class="headerBox">
      <div class="headerLeft">
        <img @click="routerPush(1)" src="../assets/img/logo2.png" alt="" />
        <h3 @click="routerPush(1)">
          <p>众力供应链</p>
          <span>打造中国领先的智慧供应链生态平台</span>
        </h3>
      </div>
      <div class="headerRight">
        <ul>
          <li :style="chooseVal === 1 ? 'color: rgba(24, 144, 255, 1)' : ''" @click="routerPush(1)">首页</li>
          <li :style="chooseVal === 2 ? 'color: rgba(24, 144, 255, 1)' : ''" @click="routerPush(2)">智慧供应链生态平台</li>
          <li :style="chooseVal === 3 ? 'color: rgba(24, 144, 255, 1)' : ''" @click="routerPush(3)">资讯中心</li>
          <li :style="chooseVal === 4 ? 'color: rgba(24, 144, 255, 1)' : ''" @click="routerPush(4)">关于我们</li>
          <li :style="chooseVal === 5 ? 'color: rgba(24, 144, 255, 1)' : ''" @click="routerPush(5)">联系我们</li>
        </ul>
        <div class="AIBox-wrapper">
          <div class="AIBox" @click="handleClickAiRobot">
            <div class="AIImg" ref="lottieRef"></div>
            <span data-text="众力供应链AI" class="AIText">众力供应链AI</span>
          </div>
        </div>
        <el-button @click="routerJump()" class="searchStyle">进入智慧供应链生态平台</el-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="dialog-wrapper" v-if="dialogVisible">
      <div class="dialog-content">
        <div class="dialog-content-header">
          <img class="dialog-content-header-img" src="../assets/img/clock.png" alt="">
        </div>
        <div class="dialog-content-body">
          <p class="desc">请先加入众力供应链集采平台，共同打造智慧供应链生态，提升采购效率，实现便捷与智能化管理！</p>
          <div class="line-through-text">是否进入</div>
          <p class="desc">倒计时结束后，自动进入集采平台</p>
          <div class="clock">
            <Countdown></Countdown>
          </div>
        </div>
        <div class="dialog-content-footer">
          <el-button type="default" size="small" @click="closeDialog">取消进入</el-button>
          <el-button type="primary" size="small" @click="handleEnter">立即进入</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from './Countdown.vue'
import * as animationData from '../assets/anime/ai_robot.json'
import Lottie from 'lottie-web'
const aiChatUrl = process.env.VUE_APP_AI_Chat_URL
export default {
  components: {
    Countdown
  },
  data() {
    return {
      chooseClassify: '',
      chooseVal: '',
      dialogVisible: false,
      timer: null,
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.path == '/home') {
      this.chooseVal = 1
    } else if (this.$route.path == '/purchaseInfo') {
      this.chooseVal = 2
      this.chooseClassify = ''
    } else if (this.$route.path == '/infoCenter') {
      this.chooseVal = 3
      this.chooseClassify = ''
    } else if (this.$route.path == '/aboutUs') {
      this.chooseVal = 4
      this.chooseClassify = ''
    } else if (this.$route.path == '/telUs') {
      this.chooseVal = 5
      this.chooseClassify = ''
    } else {
      this.chooseClassify = ''
    }
    // lottie animation
    Lottie.loadAnimation({
      container: this.$refs.lottieRef,
      renderer: 'canvas',
      loop: true,
      autoplay: true,
      animationData: animationData.default
    })
  },
  methods: {
    handleEnter() {
      this.closeDialog()
      this.routerJump()
    },
    handleClickAiRobot() {
      this.dialogVisible = true
      this.timer = setTimeout(() => {
        if (this.dialogVisible) {
          this.routerJump()
          this.dialogVisible = false
          clearTimeout(this.timer)
        }
      }, 3000)
    },
    closeDialog() {
      this.dialogVisible = false
      clearTimeout(this.timer)
    },
    routerJump() {
      window.open('https://www.z-scm.com/#/login', '_blank')
    },
    routerPush(val) {
      this.chooseVal = val
      this.chooseClassify = ''
      if (val == 1) {
        this.$router.push('/home')
      } else if (val == 2) {
        this.$router.push({ path: '/purchaseInfo' })
      } else if (val == 3) {
        this.$router.push({ path: '/infoCenter' })
      } else if (val == 4) {
        this.$router.push({ path: '/aboutUs' })
      } else if (val == 5) {
        this.$router.push({ path: '/telUs' })
      }
    },
  }
}
</script>
<style scoped lang="less">
:root {
  --color: #0ebeff;
  /* 定义 --color颜色,这里是个蓝色 */
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@keyframes rotateAnime {
  100% {
    transform: translate(-50%, -50%) rotate(1turn);
  }
}

.dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999;

  .dialog-content {
    position: absolute;
    top: 20vh;
    left: 50%;
    transform: translateX(-50%);
    width: 332px;
    height: 282px;
    background: #FFFFFF;
    border-radius: 16px 16px 16px 16px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.10);
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    gap: 12px;

    .dialog-content-header {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 58px;
      border-radius: 16px 16px 0 0;
      box-sizing: border-box;
      padding: 0 24px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      transform: translateY(-50%);
    }

    .dialog-content-header-img {
      width: 88px;
      height: 88px;
    }

    .dialog-content-body {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .desc {
        box-sizing: border-box;
        width: 100%;
        padding: 0 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 16px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        word-break: break-all;
        // 换行
        text-wrap: auto;
      }

      .clock {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 40px;
      }
    }
  }

  .dialog-content-footer {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 12px;

    /deep/ .el-button {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      font-size: 16px;
    }
  }
}

.line-through-text {
  display: flex;
  align-items: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1890FF;
  line-height: 16px;
  font-style: normal;
  text-transform: none;
}

.line-through-text::before,
.line-through-text::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #D9D9D9;
  margin: 0 10px;
}

.line-through-text span {
  white-space: nowrap;
}

.header {
  background: #fff;
  height: 80px;
  width: 100%;
  color: #ffffff;

  .headerBox {
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    line-height: 30px;

    /deep/ .el-button {
      min-width: 220px;
      height: 40px;
      border-radius: 8px;
      font-size: 16px;
    }

    .headerLeft {
      margin-top: 2px;
      display: flex;
      align-items: center;

      img {
        width: 32px;
        height: 32px;
        cursor: pointer;
      }

      h3 {
        margin: 0 40px 0 8px;
        flex-shrink: 0;
        width: 200px;
        cursor: pointer;
        line-height: 16px;

        p {
          display: block;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.8);
        }

        span {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.60);
        }
      }
    }

    .headerRight {
      display: flex;
      justify-content: flex-end;
      z-index: 999;

      ul {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        li {
          font-size: 16px;
          margin-right: 30px;
          cursor: pointer;
          color: rgba(0, 0, 0, 0.80);
          font-weight: bold;
        }

        li:hover {
          color: rgba(24, 144, 255, 1);
        }
      }

      .AIBox-wrapper {
        position: relative;
        width: auto;
        box-sizing: border-box;
        margin-right: 24px;
        // box-shadow: rgba(0, 255, 240, 0.12) 0px 2px 4px -1px, rgba(0, 71, 255, 0.08) 0px 4px 5px, rgba(0, 102, 255, 0.05) 0px 1px 10px;
        // background: conic-gradient(rgb(0, 195, 255), rgb(76, 235, 27), rgb(0, 98, 255), rgb(160, 124, 243), rgb(0, 195, 255));
        height: 40px;
        padding: 2px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        white-space: nowrap;
        z-index: 0;
        overflow: hidden;

        &::before {
          content: ' ';
          position: absolute;
          z-index: -2;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 120%;
          height: 500%;
          background-repeat: no-repeat;
          // background-size: 150% 150%;
          background-size: 50% 50%;
          background-position: 0 0;
          // background-position: center center;
          background-image: conic-gradient(rgb(0, 195, 255), rgb(0, 98, 255), rgb(160, 124, 243), rgb(0, 195, 255));
          animation: rotateAnime 2.2s linear infinite;
        }

        &::after {
          content: ' ';
          position: absolute;
          z-index: -1;
          left: 2px;
          top: 2px;
          width: calc(100% - 4px);
          height: calc(100% - 4px);
          background: white;
          border-radius: 4px;
        }
      }

      .AIBox {
        width: auto;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 4px;
        height: 100%;
        padding: 0 4px;

        .AIImg {
          margin-right: 8px;
          width: 24px;
          height: 24px;
        }

        .AIText {
          position: relative;
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          // background: conic-gradient(rgb(0, 195, 255), rgb(0, 98, 255), rgb(0, 195, 255));
          // -webkit-background-clip: text;
          // background-clip: text;
          // color: transparent;
        }

      }

      .el-button {
        min-width: 220px;
        border-radius: 0;
        border: 0;
        font-size: 16px;
        font-weight: bold;
        font-family: "SourceHanSancCN";
      }

      .searchStyle {
        padding: 9px 16px;
        height: 40px;
        background-color: rgba(24, 144, 255, 1);
        box-sizing: border-box;
        color: rgba(255, 255, 255, 1);
        line-height: 0;
      }

      .searchStyle:hover {
        background-color: rgba(24, 144, 255, .7);
        color: rgba(255, 255, 255, 1);
      }

      .headerSearch {
        margin-right: 28px;
        position: relative;
        width: 320px;
        height: 40px;
        border: 2px solid rgba(24, 144, 255, 1);
        border-radius: 4px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        overflow: hidden;

        /deep/ .el-input__inner::placeholder {
          font-family: "SourceHanSancCN", "PingFang SC", miui, system-ui, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, sans-serif;
          font-weight: bold;
          font-size: 14px;
        }

        /deep/ .searchBox {
          width: 233px;

          .el-input__inner {
            width: 233px;
          }

          .el-input__suffix-inner {
            cursor: pointer;
          }
        }

        /deep/ .el-input__inner {
          border: 0;
        }

        /deep/ .el-input-group__append {
          padding: 0 10px !important;
          border: 0;
        }

        .searchBtn {
          position: absolute;
          top: 12px;
          right: 2px;
          padding: 0 16px;
          color: rgba(0, 0, 0, 0.40);
          height: 16px;
          width: 83px;
          background-color: #fff;
          border: 0;
          border-left: 1px solid rgba(0, 0, 0, 0.10);
          cursor: pointer;
          font-size: 14px;
          font-weight: bold;
          font-family: "SourceHanSancCN";
          line-height: 16px;

          i {
            margin-left: 8px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
